import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stklg { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '日期 (LG001) 不可空白'}) 
    @MaxLength(8,{message: '日期 (LG001) 資料太長'})
    LG001: string = '';            // 日期 8 date LB002  StockBase class

    @IsNotEmpty({message: '周期(分) (LG002) 不可空白'}) 
    @MaxLength(4,{message: '周期(分) (LG002) 資料太長'})
    LG002: string = '';            // 周期(分) 4 {{0000:即時 0001:1分 0005:5分 0030:30分 0060:60分  日線:日線 月線:月線 周線:周線}}

    @IsNotEmpty({message: '時間 (LG003) 不可空白'}) 
    @MaxLength(8,{message: '時間 (LG003) 資料太長'})
    LG003: string = '';            // 時間 8 time hhmm 0000:即時 時間看 LG012

    @IsNotEmpty({message: '商品代號 (LG004) 不可空白'}) 
    @MaxLength(10,{message: '商品代號 (LG004) 資料太長'})
    LG004: string = '';            // 商品代號 10 LB001

    @IsNumber() 
    LG005: number = 0;            // 成交量 11 LB003 張數

    @IsNumber() 
    LG006: number = 0;            // 成交金額 11 =LG005*LG010*1000 qty  LB004  即時資料是 昨日量

    @IsNumber() 
    LG007: number = 0;            // 開盤價 11.3 open LB005

    @IsNumber() 
    LG008: number = 0;            // 最高價 11.3 high LB006

    @IsNumber() 
    LG009: number = 0;            // 最低價 11.3 low   LB007

    @IsNumber() 
    LG010: number = 0;            // 收盤價 11.3 close LB008

    @IsNumber() 
    LG011: number = 0;            // 昨收價 11.3 yClose LB035


    LG012: Date | undefined;            // 更新時間 0 updateTime LB054

    @MaxLength(255,{message: '操盤分析 (LG013) 資料太長'})
    LG013: string = '';            // 操盤分析 255 analysis[] LB059    TM019

    @IsNumber() 
    LG014: number = 0;            // BBand上軌 11.3 UB  LB032

    @IsNumber() 
    LG015: number = 0;            // BBand下軌 11.3 LB LB034

    @IsNumber() 
    LG016: number = 0;            // B指標 8.4 BBIndex 在BBand中位置  %b值 = (收盤價?布林帶下軌值) ÷ (布林帶上軌值?布林帶下軌值)

    @IsNumber() 
    LG017: number = 0;            // BBAND中軌 11.3 AvgBT sma20 LB033

    @IsNumber() 
    LG018: number = 0;            // BBandBW 8.4 BBandBW  帶寬指標值 = (布林帶上軌值-布林帶下軌值) ÷布林帶中軌值

    @IsNumber() 
    LG019: number = 0;            // MACD 11.3 macd LB024

    @IsNumber() 
    LG020: number = 0;            // DIF 11.3 dif LB023

    @IsNumber() 
    LG021: number = 0;            // OSC 11.3 osc

    @IsNumber() 
    LG022: number = 0;            // 振幅% 8.4 updownRate  LB058 (LG008-LG009)/LG011(昨收)

    @IsNumber() 
    LG023: number = 0;            // 漲跌幅% 8.4 pricePercent LB036 漲跌LG024/昨收LG011 Round((CASE LG011 WHEN 0 THEN 0 ELSE (LG010-LG011)/LG011 END ),3) as pricePercent

    @IsNumber() 
    LG024: number = 0;            // 漲跌 11.3 updown LB009 收盤LG010-昨收 LG011  當日股價之漲跌

    @IsNumber() 
    LG025: number = 0;            // SMA5 11.2 sma5 LB012 週 5日均價

    @IsNumber() 
    LG026: number = 0;            // SMA10 11.2 sma10 LB013   半月 10日均價

    @IsNumber() 
    LG027: number = 0;            // SMA20 11.2 sma20 LB014  月 20日均價

    @IsNumber() 
    LG028: number = 0;            // SMA60 11.2 sma60 LB018 季 60日均價

    @IsNumber() 
    LG029: number = 0;            // K(9,3) 8.4 K LB025

    @IsNumber() 
    LG030: number = 0;            // D(9,3) 8.4 D LB026

    @IsNumber() 
    LG031: number = 0;            // 買賣評分 4 buyPoint LB031

    @IsNumber() 
    LG032: number = 0;            // 週漲% 8.4 weekPercent LB037 $A5=5日前收盤LG010  (LG010-$A5)/$A5

    @IsNumber() 
    LG033: number = 0;            // 月漲% 8.4 monthPercent LB038  $A20=20日前收盤LG010  (LG010-$A20)/$A20

    @IsNumber() 
    LG034: number = 0;            // 季漲% 8.4 seasonPercent LB039  $A60=60日前收盤LG010  (LG010-$A60)/$A60

    @IsNumber() 
    LG035: number = 0;            // 量增減% 10.3 qtyPercent LB040   $A1=前一日5MA LG047 ((LG005-LG049)/LG049) (LG005-$A1)/$A1  大於3 是爆量

    @IsNumber() 
    LG036: number = 0;            // SMA5-方向 3 sma5Dir LB046 -1:下 0:平 1:上 前一天LB046 用LAB028~LAB030 CALL number2Direct ?   -1:下 0:平 1:上 收盤後計算. 當天LB012 比較 前一天

    @IsNumber() 
    LG037: number = 0;            // SMA10-方向 3 sma10Dir LB047

    @IsNumber() 
    LG038: number = 0;            // SMA20-方向 3 sma20Dir LB048

    @IsNumber() 
    LG039: number = 0;            // SMA60-方向 3 sma60Dir LB049

    @MaxLength(10,{message: '狀態 (LG040) 資料太長'})
    LG040: string = '';            // 狀態 10 state LB051  未開盤 開盤 試算isTrial 已收盤 isCloseed

    @MaxLength(255,{message: 'K線型態 (LG041) 資料太長'})
    LG041: string = '';            // K線型態 255 KLineStyle LB063  TODO:   吊人線 墓碑線 多頭吞噬 空頭吞噬 ....

    @IsNumber() 
    LG042: number = 0;            // 最新一筆成交價格 11.2 newPrice LB055

    @IsNumber() 
    LG043: number = 0;            // 離5SMA% 8.4 bias5 LB064 (LG010-LG025)/LG011(昨收)

    @IsNumber() 
    LG044: number = 0;            // 離10SMA% 8.4 bias10 LB065

    @IsNumber() 
    LG045: number = 0;            // 離20SMA% 8.4 bias20 LB061

    @IsNumber() 
    LG046: number = 0;            // 離60SMA% 8.4 bias60 LB062

    @IsNumber() 
    LG047: number = 0;            // MA5 11.2 ma5 LB016  5日均量

    @IsNumber() 
    LG048: number = 0;            // MA10 11.2 ma10 LB017  10日均量

    @IsNumber() 
    LG049: number = 0;            // 昨日量 11 

    @IsNumber() 
    LG050: number = 0;            // 殖利率 8.2 頻率:日  LI014

    @IsNumber() 
    LG051: number = 0;            // 本益比 8.2 頻率:日  LI015         每股稅後淨利(元)


}
